// app/javascript/projects/components/ProjectsDisplay.jsx

import React, { useEffect } from 'react';
import { DragItemTypes } from 'constants/DragConstants';
import { DragSource } from 'react-dnd';
import CodeLabel from './CodeLabel'
import DimensionsConstants from 'constants/DimensionsConstants'
import { getEmptyImage } from 'react-dnd-html5-backend'

const codeSource = {
  beginDrag(props) {
    props.startDrag(props.id);
    return {
      codeID: props.id,
      name: props.name,
      position: props.position,
      parent_id: props.parent_id,
      maxDepth: props.maxDepth,
    };
  },

  canDrag(props, monitor) {
    return props.draggingEnabled;
  },

  endDrag(props, monitor) {
    props.endDrag()
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview(),
  }
}

const DragCodeLabel = (props) => {
  const { connectDragSource, isDragging, connectDragPreview } = props;

  useEffect(() => {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true,
    });
  }, [connectDragPreview]);

  const cursor = props.draggingEnabled
    ? (isDragging ? 'grabbing' : 'grab')
    : undefined;

  return connectDragSource(
    <div className='codeLabel' style={{width: DimensionsConstants.CODE_LABEL_WIDTH, cursor}}>
      <div
        style={{
          border: "1px solid white"
        }}>
        <CodeLabel
          maxDepth={props.maxDepth}
          initiateMergeCode={props.initiateMergeCode}
          transitionType={props.transitionType}
          name={props.name}
          color={props.color}
          id={props.id}
          newCode={props.newCode}
          count={props.count}
          mergeParent={props.mergeParent}
          showConfirmMerge={props.showConfirmMerge}
          onShowMerge={props.onShowMerge}
          collapsed={props.collapsed}
          selected={props.selected}
          onClick={props.onClick}
          disabled={props.disabled}
          deleteCode={props.deleteCode}
          dragOver={props.dragOver && !isDragging}
          canMergeHere={props.canMergeHere}
          isDragging={isDragging}
          ghost={props.ghost}
          onCollapseClicked={props.onCollapseClicked}
          isSearching={props.isSearching}
          cancelMerge={props.cancelMerge}
          confirmMerge={props.confirmMerge}
          allowDropdown={props.allowDropdown}
          renameCode={props.renameCode}
          onRename={props.onRename}
          renameMode={props.renameMode}
          setConfirmDrag={props.setConfirmDrag}
        />
      </div>
    </div>
  );
};

export default DragSource(DragItemTypes.CODE_LABEL, codeSource, collect)(DragCodeLabel);